import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getRecipientName } from "./fulfillment-group-csv-utils";

export const RecipientNameCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Recipient",
    cell: (row) => {
      return getRecipientName(row);
    },
  };
